module.exports = __webpack_public_path__ + "img/ppt-default.1636444d.jpg";